import { useEffect } from "react";
import { NewOrderStep, useNewOrderStore } from "../stores/order.store";
import { ChooseAudioResponsibleLayout } from "./orders/components/ChooseAudioResponsibleLayout";
import { ChooseCommandTypeLayout } from "./orders/components/ChooseCommandTypeLayout";
import { ChooseEarprintShippingTypeLayout } from "./orders/components/ChooseEarprintShippingTypeLayout";
import { ChooseSetupLayout } from "./orders/components/ChooseSetupLayout";
import { ChooseShippingLayout } from "./orders/components/ChooseShippingLayout";
import { ValidationLayout } from "./orders/components/ValidationLayout";
import { ChooseRenewReasonLayout } from "./orders/components/ChooseRenewReasonLayout";
import { ChooseRenewCommandsLayout } from "./orders/components/ChooseRenewCommandsLayout";

/**
 * Switch between new order steps.
 */
const OrdersNewPage = () => {
	const { getStep, reload } = useNewOrderStore();

	useEffect(() => {
		// A bit brutal, but fix some issues related to draft undefined values not being saved
		reload();
	}, [reload]);

	const step = getStep();
	switch (step) {
		case NewOrderStep.CHOOSE_AUDIO_RESPONSIBLE:
			return <ChooseAudioResponsibleLayout />;
		case NewOrderStep.CHOOSE_COMMAND_TYPE:
			return <ChooseCommandTypeLayout />;
		case NewOrderStep.CHOOSE_EARPRINT_SHIPPING_TYPE:
			return <ChooseEarprintShippingTypeLayout />;
		case NewOrderStep.CHOOSE_SETUP:
			return <ChooseSetupLayout />;
		case NewOrderStep.CHOOSE_SHIPPING:
			return <ChooseShippingLayout />;
		case NewOrderStep.VALIDATION:
			return <ValidationLayout />;
		case NewOrderStep.CHOOSE_RENEW_REASON:
			return <ChooseRenewReasonLayout />;
		case NewOrderStep.CHOOSE_RENEW_COMMANDS:
			return <ChooseRenewCommandsLayout />;
		case NewOrderStep.CHOOSE_RENEW_SETUP:
			return <ChooseSetupLayout />;
		default:
			throw new Error(step satisfies never);
	}
};

export default OrdersNewPage;
